import React from 'react'
import { Accordion, AccordionDetails, AccordionSummary, Button, Card, CardContent, ClickAwayListener, Divider, Grid, Grow, ListItemIcon, ListItemText, MenuItem, MenuList, Paper, Popper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@material-ui/core';
import { useStyles } from './styles'
import 'react-toastify/dist/ReactToastify.css'
import { FaEdit } from 'react-icons/fa';
import { Link } from 'react-router-dom';

function ProductsTableBody(props: any) {
    const classes = useStyles();

    return (
        <>
            <TableRow>
                <TableCell className={classes.tableCell}>{props.i + 1}</TableCell>
                <TableCell className={classes.tableCell}>{props.roomData?.name}</TableCell>
                <TableCell className={classes.tableCell}>
                    <span
                    style={{
                        color: props.roomData?.status == 1 ? "green" : "black",
                        textTransform: "capitalize"
                    }}
                    >{props.roomData?.status == 1 ? "Active" : "Inactive"}</span>
                </TableCell>
                <TableCell className={classes.tableCell}>
                    <Link
                        to={"/dashboard/settings/products/edit/" + props.roomData?._id}>
                        <FaEdit />
                    </Link>
                </TableCell>
            </TableRow>
        </>
    )
}

export default ProductsTableBody